module.exports = __webpack_public_path__ + "media/npc_dota_hero_abaddon.3633b7db.webm";